import Chart from "react-apexcharts"

const VisitsChart = ({ timeline, newCustomersTimeline, repeatCustomersTimeline }) => {
  const options = {
    chart: {
      id: "visits-chart",
      toolbar: { show: false }, 
      zoom: { enabled: true }, 
    },
    xaxis: { categories: timeline },
    stroke: { curve: "smooth" },
    markers: { size: 4 },
    tooltip: { shared: true, intersect: false },
    colors: ["#1E90FF", "#28A745"], 
  }

  const series = [
    {
      name: "Repeat Customers",
      data: repeatCustomersTimeline,
    },
    {
      name: "New Customers",
      data: newCustomersTimeline,
    },
  ]

  return <Chart options={options} series={series} type="line" height={350} />
}

export default VisitsChart
